import { defineMessages } from 'react-intl';

export default defineMessages({
  publisher: {
    id: 'app.components.UserList.publisher',
    defaultMessage: 'Publisher',
  },
  assignmentRatio: {
    id: 'app.components.UserList.assignmentRatio',
    defaultMessage: 'Assignments',
  },
  car: {
    id: 'app.components.UserList.car',
    defaultMessage: 'Car',
  },
  experience: {
    id: 'app.components.UserList.experience',
    defaultMessage: 'Experience',
  },
  teamLead: {
    id: 'app.components.UserList.teamLead',
    defaultMessage: 'Lead',
  },
  vip: {
    id: 'app.components.UserList.vip',
    defaultMessage: 'VIP',
  },
  visible: {
    id: 'app.components.UserList.visible',
    defaultMessage: 'Visible',
  },
  assignmentRatioExplanation: {
    id: 'app.components.UserList.assignmentRatioExplanation',
    defaultMessage: '(recommended) assignment count / application count',
  },
});
